import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import {
  DetailModalContent,
  DetailModalHeader,
  DetailModalTitle,
  DetailModalBody,
  DetailModalImageWrapper,
  DetailModalImage,
  DetailModalImageContent,
  DetailModalPromoTitle,
  DetailModalPrice,
  DetailModalShortDesc,
  DetailModalSection,
  DetailModalSectionContent,
  DetailModalFooter,
  DetailModalSecondaryButton,
  DetailModalPrimaryButton,
  ModalCloseButton,
  DetailModalDeselectButton,
} from './Modal.styles';
import { EmailIcon } from './icons';
import { SuggestedBadge } from './PromotionCard.styles';

const DetailModal = ({ open, promotion, onClose, onConfirm, onDeselect, selectedPromotionIds }) => {
  const [innerWidth, setInnerWidth] = React.useState(window?.innerWidth || 0);
  React.useEffect(() => {
    const handleResize = () => setInnerWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!promotion) return null;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={640}
      closable={false}
      style={{
        marginTop: innerWidth < 1400 ? 0 : undefined,
        top: innerWidth < 1400 ? 0 : undefined,
      }}
      bodyStyle={{ padding: 0 }}
    >
      <DetailModalContent>
        <DetailModalHeader>
          <DetailModalTitle>Deine Auswahl</DetailModalTitle>
          <ModalCloseButton onClick={onClose}>
            <CloseOutlined />
          </ModalCloseButton>
        </DetailModalHeader>

        <DetailModalBody>
          <DetailModalImageWrapper>
            <DetailModalImage>
              {promotion.image_url && (
                <img src={promotion.image_url} alt={promotion.title} />
              )}
            </DetailModalImage>
            <DetailModalImageContent
              style={{
                background: promotion.green_flag ? '#F5FBEE' : undefined,
              }}
            >
              <DetailModalPromoTitle>{promotion.title}</DetailModalPromoTitle>
              {promotion.subtitle && (
                <DetailModalPrice>{promotion.subtitle}</DetailModalPrice>
              )}
              {promotion.description && (
                <DetailModalShortDesc
                  dangerouslySetInnerHTML={{ __html: promotion.description }}
                />
              )}
            </DetailModalImageContent>
          </DetailModalImageWrapper>

          {promotion.long_description && (
            <DetailModalSection>
              <DetailModalSectionContent
                dangerouslySetInnerHTML={{ __html: promotion.long_description }}
              />
            </DetailModalSection>
          )}
        </DetailModalBody>

        <DetailModalFooter>
          <DetailModalSecondaryButton onClick={onClose}>
            Abbrechen
          </DetailModalSecondaryButton>

          {selectedPromotionIds.includes(promotion.id) ? (
            <DetailModalDeselectButton onClick={onDeselect}>
              Auswahl aufheben
            </DetailModalDeselectButton>
          ) : (
            <DetailModalPrimaryButton onClick={onConfirm}>
              <EmailIcon />
              Unverbindlich anfragen
            </DetailModalPrimaryButton>
          )}
        </DetailModalFooter>
      </DetailModalContent>
    </Modal>
  );
};

DetailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  promotion: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    long_description: PropTypes.string,
    image_url: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

DetailModal.defaultProps = {
  promotion: null,
};

export default DetailModal;
